// src/features/rating/hooks/use-unrated-events.ts
import { rqClient } from "../../shared/api/instance";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryClient } from "../../shared/api/query-client";
// import { useAppState } from "@/state";

export function useGetUnratedEvents(customerId) {
  return useQuery(
    rqClient.queryOptions(
      "get",
      "/events/v1/events/without-rating",
      {
        params: {
          query: {
            customerId,
            page: 0,
            size: 10,
          },
        },
      },
      {
        enabled: !!customerId,
      }
    )
  );
}

// Хук для инвалидации
export function useInvalidateUnratedEvents() {
  return ({ customerId, sort }) => {
    queryClient.invalidateQueries({
      queryKey: rqClient.queryOptions(
        "get",
        "/events/v1/events/without-rating",
        {
          params: {
            query: {
              customerId,
              page: 0,
              size: 10,
            },
          },
        }
      ).queryKey,
    });
  };
}

export function useRateEvent() {
  return rqClient.useMutation("post", "/events/v1/events/{id}/rate", {
    // params: {
    //   path: { id: eventId }
    // },
  });
}
